<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import Logger from '@/logger'
import { ErrorMessage } from '@/common/components/Message'
import { UnauthorizedError } from '@/common/api/errors'

@Component({
  components: { ErrorMessage }
})
class ErrorBoundary extends Vue {
  @Action('auth/logout') logoutUser
  @Prop(Error) error
  caughtError = null

  errorCaptured (error) {
    if (error instanceof UnauthorizedError) {
      Logger.warn('User unauthorized. Logging out.')
      this.logoutUser()
      return false
    }

    Logger.error(error)
    this.caughtError = error
  }

  get actualError () {
    return this.caughtError || this.error
  }

  render (createElement) {
    return this.actualError
      ? createElement('ErrorMessage', { props: { errorCode: String(this.actualError.code || '') } })
      : this.$slots.default[0]
  }
}

export default ErrorBoundary
</script>
